/* eslint-disable @typescript-eslint/require-await */
import {
   AppointmentAdvancePaymentRefund,
   AppointmentAdvancePaymentRefundQuery,
   RefundConfiguration,
   RefundConfigurationQuery,
} from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { VisitSettlement, VisitSettlementQuery } from '@dreryk/egabinet-financial-settlement-frontend-api';
import { PurchaseId } from '@dreryk/egabinet-financial-settlement-published-language-api';
import { AppointmentDetails, AppointmentDetailsQuery } from '@dreryk/egabinet-appointment-frontend-api';

import { performCqrsQueryFind, performCqrsQueryGet } from '@dreryk/command-query-react-common';

import { protectFeature } from '~libs.shared.system';

export const performRefundConfigurationCqrsFind = async (): Promise<RefundConfiguration | null> => {
   return protectFeature(
      'searchingPrivateMedicalServices',
      async () => performCqrsQueryFind<RefundConfiguration>(() => new RefundConfigurationQuery()),
      () => null
   )();
};

export const performAppointmentDetailsCqrsGet = async (appointmentId: number): Promise<AppointmentDetails> => {
   return performCqrsQueryGet<AppointmentDetails>(() => {
      const query = new AppointmentDetailsQuery();
      query.appointmentId = AppointmentId.of(appointmentId);
      return query;
   });
};

export const performVisitSettlementCqrsFind = async (appointmentId: number): Promise<VisitSettlement | null> => {
   return protectFeature(
      'searchingPrivateMedicalServices',
      async () =>
         performCqrsQueryFind<VisitSettlement>(() => {
            const query = new VisitSettlementQuery();
            query.purchaseIds = [PurchaseId.forAppointment(AppointmentId.of(appointmentId))];
            return query;
         }),
      () => null
   )();
};

export const performAppointmentAdvancePaymentRefundCqrsFind = async (parameters: {
   appointmentId: number;
   automaticRefundEnabled: boolean;
}): Promise<AppointmentAdvancePaymentRefund | null> => {
   return protectFeature(
      'searchingPrivateMedicalServices',
      async () => {
         if (!parameters.automaticRefundEnabled) {
            return null;
         }

         return performCqrsQueryFind<AppointmentAdvancePaymentRefund>(() => {
            const query = new AppointmentAdvancePaymentRefundQuery();
            query.appointmentId = AppointmentId.of(parameters.appointmentId);
            return query;
         });
      },
      () => null
   )();
};
